import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";
import { resendAwardEmail } from "../api/award-api";
import type { ResendEmailResponse } from "../api/award-api";
import { awardsQueryKey } from "./useAwards";

/**
 * Mutation hook for re-sending a supplier's award notification email. On
 * success it invalidates the awards cache so the row's `email_status` updates.
 */
export const useResendAwardEmail = (
	rfxId: number | undefined,
	evalId: number | undefined
): UseMutationResult<ResendEmailResponse, Error, number> => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (inviteId: number) =>
			resendAwardEmail(rfxId!, evalId!, inviteId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: awardsQueryKey(rfxId ?? 0, evalId ?? 0),
			});
		},
	});
};
